<template>
  <div>
    <div v-if="showCombinePrice" :class="columnLayout ? 'row' : ''">
      <div v-for="item in pricingInfoList" :key="item">
        <PriceValueItem
          v-if="getItemPlacement(item, 'Booking Rate')"
          :label="getLabel('Booking Rate')"
          :viewOnly="true"
          :columnLayout="columnLayout"
          v-model="totalHourlyRate"
          :isPerHourRate="true"
        />
        <PriceValueItem
          v-if="getItemPlacement(item, 'Booking Fee')"
          :label="getLabel('Booking Fee')"
          :viewOnly="true"
          :columnLayout="columnLayout"
          v-model="totalFlatRate"
        />
        <PriceValueItem
          v-if="perBookingFlatRate && getItemPlacement(item, 'Per Booking Fee')"
          :label="getLabel('Per Booking Fee')"
          :viewOnly="true"
          :columnLayout="columnLayout"
          v-model="perBookingFlatRate"
        />
      </div>
    </div>
    <div v-if="!showCombinePrice || isAgent" :class="columnLayout ? 'row' : ''">
      <div v-for="(item, index) in pricingInfoList" :key="index">
        <PriceValueItem
          v-if="showTotalBookingFee && getItemPlacement(item, 'Booking Fee')"
          :label="getLabel('Booking Fee')"
          :viewOnly="true"
          :columnLayout="columnLayout"
          v-model="totalFlatRate"
        />
        <PriceValueItem
          v-if="
            (isAgent || getIsShowPriceToClient('Client Rate')) &&
            getItemPlacement(item, 'Client Rate')
          "
          :label="getLabel('Client Rate')"
          :viewOnly="true"
          :columnLayout="columnLayout"
          v-model="clientRate"
          :isPerHourRate="true"
        />
        <PriceValueItem
          v-if="
            (isAgent || getIsShowPriceToClient('Candidate Rate')) &&
            getItemPlacement(item, 'Candidate Rate')
          "
          :label="getLabel('Candidate Rate')"
          :viewOnly="viewOnly"
          :columnLayout="columnLayout"
          v-model="candidateRate"
          :isPerHourRate="true"
        />
        <PriceValueItem
          v-if="
            (isAgent || getIsShowPriceToClient('Agency Fee')) &&
            getItemPlacement(item, 'Agency Fee')
          "
          :label="getLabel('Agency Fee')"
          :viewOnly="viewOnly"
          :columnLayout="columnLayout"
          v-model="agencyRate"
          :isPerHourRate="true"
        />
        <p
          :class="columnLayout ? 'col-lg-6' : ''"
          v-if="
            numberOfBookingUsingCredit &&
            numberOfBookingNotUsingCredit === 0 &&
            calculateFee('agency_fee', calculateAgencyFee) &&
            getItemPlacement(item, 'Agency Fee')
          "
        >
          <label>{{ getLabel("Agency Fee") }}:</label>
          <span> Use Booking Credit </span>
        </p>
        <PriceValueItem
          v-if="
            (isAgent || getIsShowPriceToClient('Travel Fee')) &&
            getItemPlacement(item, 'Travel Fee')
          "
          :label="getLabel('Travel Fee')"
          :viewOnly="viewOnly"
          :columnLayout="columnLayout"
          v-model="travelFee"
        />
        <PriceValueItem
          v-if="isAgent && getItemPlacement(item, 'Rush Fee')"
          :label="getLabel('Rush Fee')"
          :viewOnly="viewOnly"
          :columnLayout="columnLayout"
          v-model="rushFee"
        />
        <div v-if="getItemPlacement(item, 'Candidate Rush Fee')">
          <PriceValueItem
            v-if="isAgent"
            :label="getLabel('Candidate Rush Fee')"
            :viewOnly="viewOnly"
            :columnLayout="columnLayout"
            v-model="candidateRushFee"
          />
          <PriceValueItem
            v-else
            :label="getLabel('Rush Fee')"
            :viewOnly="true"
            :columnLayout="columnLayout"
            :value="totalRushFee"
          />
        </div>
        <PriceValueItem
          v-if="
            (isAgent || getIsShowPriceToClient('Per Booking Agency Fee')) &&
            getItemPlacement(item, 'Per Booking Agency Fee')
          "
          :label="getLabel('Per Booking Agency Fee')"
          :viewOnly="viewOnly"
          :columnLayout="columnLayout"
          v-model="perBookingAgencyFee"
        />
        <p
          :class="columnLayout ? 'col-lg-6' : ''"
          v-if="
            numberOfBookingUsingCredit &&
            numberOfBookingNotUsingCredit === 0 &&
            calculateFee('per_booking_agency_fee', getPerBookingAgencyFee) &&
            getItemPlacement(item, 'Per Booking Agency Fee')
          "
        >
          <label>{{ getLabel("Per Booking Agency Fee") }}:</label>
          <span> Use Booking Credit </span>
        </p>
        <PriceValueItem
          v-if="
            (isAgent || getIsShowPriceToClient('Per Booking Candidate Fee')) &&
            getItemPlacement(item, 'Per Booking Candidate Fee')
          "
          :label="getLabel('Per Booking Candidate Fee')"
          :viewOnly="viewOnly"
          :columnLayout="columnLayout"
          v-model="perBookingCandidateFee"
        />
        <PriceValueItem
          v-if="
            (isAgent || getIsShowPriceToClient('Admin Fee')) &&
            getItemPlacement(item, 'Admin Fee')
          "
          :label="getLabel('Admin Fee')"
          :viewOnly="viewOnly"
          :columnLayout="columnLayout"
          v-model="adminFee"
        />
        <PriceValueItem
          v-if="
            (isAgent || getIsShowPriceToClient('Admin Percentage Fee')) &&
            getItemPlacement(item, 'Admin Percentage Fee')
          "
          :label="getLabel('Admin Percentage Fee')"
          :viewOnly="viewOnly"
          :columnLayout="columnLayout"
          v-model="adminFeeSubstraction"
        />
        <PriceValueItem
          v-if="
            (isAgent || getIsShowPriceToClient('Additional Fees')) &&
            getItemPlacement(item, 'Additional Fees')
          "
          :label="getLabel('Additional Fees')"
          :viewOnly="viewOnly"
          :columnLayout="columnLayout"
          v-model="job.additional_fee"
        />
        <PriceValueItem
          v-if="
            totalDiscount && getItemPlacement(item, 'Booking Total Discount')
          "
          label="Booking Total Discount"
          :viewOnly="true"
          :columnLayout="columnLayout"
          v-model="totalDiscount"
        />
      </div>
    </div>
  </div>
</template>
<script>
import PRICE_INFO_CALCULATION_MIXIN from "./PriceInfoCalculation";
import PriceValueItem from "./PriceValueItem";
import { mapGetters, mapActions } from "vuex";
import { CUSTOMIZE_PRICE_INFO_TEXT_OPTIONS } from "../../../constants/options";
import { FORM_TYPE, PRICE_TYPES } from "../../../constants/custom-define-type";
import { DEFAULT_PRICE_INFO_ITEMS_PLACEMENT } from "../../../constants/default-values";

export default {
  name: "BookingPriceInfo",
  components: { PriceValueItem },
  props: {
    job: Object,
    originalJob: Object,
    categoryList: {
      type: String,
      default: "",
    },
    user: {
      type: Object,
      default: () => {},
    },
    listPrices: {
      type: Array,
      default: () => [],
    },
    columnLayout: {
      type: Boolean,
      default: false,
    },
    selectedDate: String,
    // If number of children is more than that, additional fee will be added
    numberOfAllowedChildren: {
      type: Number,
      default: 1,
    },
    numberOfBooking: {
      type: Number,
      default: 1,
    },
    numberOfBookingUsingCredit: {
      type: Number,
      default: 0,
    },
    viewOnly: {
      type: Boolean,
      default: false,
    },
    listDateTimesOfJobs: Array,
    listBookingDates: Array,
    forceRecalculate: {
      type: Boolean,
      default: false,
    },
    isInApplicationForm: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [PRICE_INFO_CALCULATION_MIXIN],
  data() {
    return {
      candidateRateModified: null,
      agencyRateModified: null,
      travelFeeModified: null,
      rushFeeModified: null,
      candidateRushFeeModified: null,
      perBookingAgencyFeeModified: null,
      perBookingCandidateFeeModified: null,
      totalHourlyRateModified: null,
      totalFlatRateModified: null,
      adminFeeModified: null,
      adminFeeSubstractionModified: null,
      DEFAULT_PRICE_INFO_ITEMS_PLACEMENT,
    };
  },
  computed: {
    ...mapGetters([
      "isAgent",
      "showCandidateRateToClient",
      "showClientRateToClient",
      "placementOfPriceInfoFields",
    ]),
    numberOfBookingNotUsingCredit() {
      return this.numberOfBooking - this.numberOfBookingUsingCredit;
    },
    bookingDuration() {
      if (
        this.listDateTimesOfJobs &&
        this.listDateTimesOfJobs.length > 1 &&
        this.job.start_time &&
        this.job.end_time
      ) {
        const totalDuration = this.listDateTimesOfJobs.reduce((acc, cur) => {
          return (
            acc +
            this.calculateDuration(
              cur.date,
              cur.startTime,
              cur.date,
              cur.endTime
            )
          );
        }, 0);
        return totalDuration.toFixed(2);
      }
      const startDate = this.job.date || this.selectedDate;
      return (
        this.calculateDuration(
          startDate,
          this.getTimeString(this.job.start_time),
          this.job.end_date ? this.job.end_date : startDate,
          this.getTimeString(this.job.end_time)
        ) * this.numberOfBooking
      ).toFixed(2);
    },
    showCombinePrice() {
      return (
        this.$store.getters.agencyPublic &&
        this.$store.getters.agencyPublic.public_advance_setting &&
        this.$store.getters.agencyPublic.public_advance_setting
          .show_combined_booking_price
      );
    },
    showTotalBookingFee() {
      return (
        this.$store.getters.agencyPublic &&
        this.$store.getters.agencyPublic.public_advance_setting &&
        this.$store.getters.agencyPublic.public_advance_setting
          .show_total_booking_fee
      );
    },
    clientRate() {
      // Check if agency rate or candidate rate changed
      const isCandidateRateChanged = this.isFeeChanged(
        this.calculateCandidateRate
      );
      const isAgencyRateChanged = this.isFeeChanged(this.calculateAgencyFee);
      if (!isCandidateRateChanged && !isAgencyRateChanged) {
        if (
          this.originalJob &&
          this.originalJob.client_rate &&
          this.originalJob.client_rate !== "0.00"
        ) {
          return Number(this.originalJob.client_rate);
        }
      }
      let result = 0;
      if (this.candidateRate && !isNaN(this.candidateRate)) {
        result = Number(this.candidateRate);
      }
      if (this.agencyRate && !isNaN(this.agencyRate)) {
        result = result + Number(this.agencyRate);
      }
      return result;
    },
    candidateRate: {
      get() {
        if (this.candidateRateModified != null) {
          return this.candidateRateModified;
        }
        return this.calculateFee("candidate_rate", this.calculateCandidateRate);
      },
      set(val) {
        this.candidateRateModified = val;
      },
    },
    agencyRate: {
      get() {
        if (!this.numberOfBookingNotUsingCredit) {
          return 0;
        }
        if (this.agencyRateModified != null) {
          return this.agencyRateModified;
        }
        return this.calculateFee("agency_fee", this.calculateAgencyFee);
      },
      set(val) {
        this.agencyRateModified = val;
      },
    },
    travelFee: {
      get() {
        if (this.travelFeeModified != null) {
          return this.travelFeeModified;
        }
        return this.calculateFee(
          "travel_fee",
          this.calculateTravelFee,
          this.numberOfBooking
        );
      },
      set(val) {
        this.travelFeeModified = val;
      },
    },
    travelFeePerBooking() {
      if (!this.numberOfBooking || !this.travelFee) {
        return this.travelFee;
      }
      if (this.job && this.job.travel_fee && this.travelFeeModified == null) {
        return this.roundNumberTwoDigits(Number(this.job.travel_fee));
      }
      return this.roundNumberTwoDigits(
        Number(this.travelFee) / this.numberOfBooking
      );
    },
    rushFee: {
      get() {
        if (this.rushFeeModified != null) {
          return this.rushFeeModified;
        }
        return this.calculateFee(
          "rush_fee",
          this.calculateRushFee,
          this.numberOfBooking
        );
      },
      set(val) {
        this.rushFeeModified = val;
      },
    },
    rushFeePerBooking() {
      if (!this.numberOfBooking || !this.rushFee) {
        return this.rushFee;
      }
      return this.roundNumberTwoDigits(
        Number(this.rushFee) / this.numberOfBooking
      );
    },
    candidateRushFee: {
      get() {
        if (this.candidateRushFeeModified != null) {
          return this.candidateRushFeeModified;
        }
        return this.calculateFee(
          "candidate_rush_fee",
          this.calculateCandidateRushFee,
          this.numberOfBooking
        );
      },
      set(val) {
        this.candidateRushFeeModified = val;
      },
    },
    candidateRushFeePerBooking() {
      if (!this.numberOfBooking || !this.candidateRushFee) {
        return this.candidateRushFee;
      }
      return this.roundNumberTwoDigits(
        Number(this.candidateRushFee) / this.numberOfBooking
      );
    },
    totalRushFee() {
      let result = 0;
      if (this.rushFee) {
        result += Number(this.rushFee);
      }
      if (this.candidateRushFee) {
        result += Number(this.candidateRushFee);
      }
      return result;
    },
    perBookingAgencyFee: {
      get() {
        if (!this.numberOfBookingNotUsingCredit) {
          return 0;
        }
        if (this.perBookingAgencyFeeModified != null) {
          return this.perBookingAgencyFeeModified;
        }
        return this.calculateFee(
          "per_booking_agency_fee",
          this.getPerBookingAgencyFee
        );
      },
      set(val) {
        this.perBookingAgencyFeeModified = val;
      },
    },
    totalDiscount() {
      return this.getTotalDiscount({
        ...this.job,
        bulk_count: this.numberOfBooking,
      });
    },
    totalPerBookingAgencyFee() {
      if (!this.numberOfBookingNotUsingCredit) {
        return 0;
      }
      if (!this.numberOfBookingNotUsingCredit || !this.perBookingAgencyFee) {
        return this.perBookingAgencyFee;
      }
      return this.roundNumberTwoDigits(
        Number(this.perBookingAgencyFee) * this.numberOfBookingNotUsingCredit
      );
    },
    perBookingCandidateFee: {
      get() {
        if (this.perBookingCandidateFeeModified != null) {
          return this.perBookingCandidateFeeModified;
        }
        return this.calculateFee(
          "per_booking_candidate_fee",
          this.getPerBookingCandidateFee
        );
      },
      set(val) {
        this.perBookingCandidateFeeModified = val;
      },
    },
    totalPerBookingCandidateFee() {
      if (!this.numberOfBooking || !this.perBookingCandidateFee) {
        return this.perBookingCandidateFee;
      }
      return this.roundNumberTwoDigits(
        Number(this.perBookingCandidateFee) * this.numberOfBooking
      );
    },
    adminFee: {
      get() {
        if (this.adminFeeModified != null) {
          return this.adminFeeModified;
        }
        if (this.job && this.job.admin_fee) {
          if (this.job.admin_fee === "0.00") {
            return 0;
          }
          return this.job.admin_fee;
        }
        const totalFee = this.totalFlatRateExcludeAdminFee;
        const adminFee = this.getAdminFeeOfJob(this.job, totalFee);
        return adminFee;
      },
      set(val) {
        this.adminFeeModified = val;
      },
    },
    adminFeePerBooking() {
      if (!this.numberOfBooking || !this.adminFee) {
        return this.adminFee;
      }
      return this.roundNumberTwoDigits(
        Number(this.adminFee) / this.numberOfBooking
      );
    },
    adminFeeSubstraction: {
      get() {
        if (this.adminFeeSubstractionModified != null) {
          return this.adminFeeSubstractionModified;
        }
        if (this.job && this.job.admin_fee_subtraction) {
          if (this.job.admin_fee_subtraction === "0.00") {
            return 0;
          }
          return this.job.admin_fee_subtraction;
        }
        const totalFee = this.totalFlatRateExcludeAdminFee;
        const adminFee = this.getAdminFeeOfJob(
          this.job,
          totalFee,
          PRICE_TYPES.ADMIN_PERCENTAGE
        );
        return adminFee;
      },
      set(val) {
        this.adminFeeSubstractionModified = val;
      },
    },
    adminFeeSubstractionPerBooking() {
      if (!this.numberOfBooking || !this.adminFeeSubstraction) {
        return this.adminFeeSubstraction;
      }
      return this.roundNumberTwoDigits(
        Number(this.adminFeeSubstraction) / this.numberOfBooking
      );
    },
    totalHourlyRate: {
      get() {
        if (this.totalHourlyRateModified != null) {
          return this.totalHourlyRateModified;
        }
        let result = 0;
        if (this.candidateRate) {
          result += Number(this.candidateRate);
        }
        if (this.agencyRate) {
          result += Number(this.agencyRate);
        }
        return result;
      },
      set(val) {
        this.totalHourlyRateModified = val;
      },
    },
    totalFlatRateExcludeAdminFee() {
      if (this.totalFlatRateModified != null) {
        if (this.adminFee) {
          return Number(this.totalFlatRateModified) - Number(this.adminFee);
        } else {
          return this.totalFlatRateModified;
        }
      }
      let result = 0;
      if (this.travelFee) {
        result += Number(this.travelFee);
      }
      if (this.rushFee) {
        result += Number(this.rushFee);
      }
      if (this.candidateRushFee) {
        result += Number(this.candidateRushFee);
      }
      if (this.totalPerBookingAgencyFee) {
        result += Number(this.totalPerBookingAgencyFee);
      }
      if (this.totalPerBookingCandidateFee) {
        result += Number(this.totalPerBookingCandidateFee);
      }
      if (this.candidateRate) {
        result += Number(this.candidateRate) * Number(this.bookingDuration);
      }
      if (this.agencyRate) {
        result += Number(this.agencyRate) * Number(this.bookingDuration);
      }
      if (this.job.additional_fee) {
        result += Number(this.job.additional_fee);
      }
      return result;
    },
    totalFlatRate: {
      get() {
        if (this.adminFee) {
          return (
            Number(this.totalFlatRateExcludeAdminFee) + Number(this.adminFee)
          );
        } else {
          return this.totalFlatRateExcludeAdminFee;
        }
      },
      set(val) {
        this.totalFlatRateModified = val;
      },
    },
    candidateFee() {
      return this.calculateCandidateFee(this.job);
    },
    perBookingFlatRate() {
      if (this.totalFlatRate && this.job.repeat) {
        return this.totalFlatRate / this.numberOfBooking;
      }
      return 0;
    },
    pricingInfoList() {
      if (this.placementOfPriceInfoFields.length) {
        return this.placementOfPriceInfoFields;
      }
      return this.DEFAULT_PRICE_INFO_ITEMS_PLACEMENT;
    },
  },
  methods: {
    ...mapActions(["setRushFeeInfo"]),
    isFeeChanged(feeFunction, rate = null) {
      // Calculated fee
      if (rate == null) {
        rate = feeFunction(this.job);
      }
      // Check if fee, rate changed because of updating booking
      if (this.originalJob && Object.keys(this.originalJob).length) {
        const originalRate = feeFunction(this.originalJob);
        if (originalRate !== rate) {
          return true;
        }
      }
      return false;
    },
    calculateFee(model, feeFunction, numberOfBooking) {
      console.log(model, this.job);
      if (this.forceRecalculate) {
        // Change to a non exist model to recalculate fee
        model = "non_existed";
      }
      // Calculated fee
      const rate = feeFunction(this.job);
      console.log(rate);
      const isFeeChanged = this.isFeeChanged(feeFunction, rate);
      if (!isFeeChanged) {
        // Saved fee (It might be adjusted by agency)
        if (this.job && model in this.job) {
          if (this.job[model] === "0.00") {
            return 0;
          }
          return this.job[model];
        }
      }
      if (rate) {
        if (numberOfBooking > 1) {
          if (model.indexOf("rush_fee") >= 0) {
            // Calculate rate for each booking
            let result = 0;
            const listRushFee = [];
            for (const dateTime of this.listBookingDates) {
              const bookingRate = feeFunction({
                ...this.job,
                date: dateTime.date,
              });
              listRushFee.push({
                ...dateTime,
                fee: bookingRate,
              });
              if (bookingRate) {
                result += bookingRate;
              }
            }
            if (model === "rush_fee") {
              this.setRushFeeInfo({
                listFees: listRushFee,
                listDates: this.listBookingDates,
              });
            }
            return result;
          }
          return rate * numberOfBooking;
        } else {
          return rate;
        }
      }
    },
    getLabel(label) {
      const item = CUSTOMIZE_PRICE_INFO_TEXT_OPTIONS.find(
        (item) => item.label === label
      );
      if (!item) {
        return label;
      }
      const settingLabel = this.tryGet(
        () =>
          this.$store.getters.agencyPublic.public_advance_setting[item.model]
      );
      if (settingLabel && settingLabel !== item.label) {
        return settingLabel;
      }
      return (
        this.getLabelByKeys("BOOKING_SECTION.PRICES." + item.key) ||
        settingLabel
      );
    },
    getIsShowPriceToClient(label) {
      const item = CUSTOMIZE_PRICE_INFO_TEXT_OPTIONS.find(
        (item) => item.label === label
      );
      if (item) {
        const result = this.tryGet(
          () =>
            this.$store.getters.agencyPublic.public_advance_setting[
              `show_${item.key.toLowerCase()}_to_client`
            ]
        );
        if (result != null && result !== "") {
          return result;
        }
      }
      return true; // Default is true
    },
    getItemPlacement(item, field) {
      if (item === field) {
        return true;
      }
      return false;
    },
  },
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/common/bookings/BookingPriceInfo.vue